/* Etiquetas multiidoma en castellano. */
export default {
  "qrScanner.lanternButton": "Linterna",
  "qrScanner.closeButton": "Cerrar",
};
